import { CostCodeLookup } from "./TypeExtensions";
import { Maybe } from "../sharedCode/avroGraphql";
import { HasValue } from "../sharedCode/HelperMethods";
import { MINIMUMS_VISIBLE_COMPANIES } from "../sharedCode/metadata";

export function getByKeyHash(list: CostCodeLookup[], keyHash: string): CostCodeLookup | undefined {
    if (!list) {
        return undefined;
    }

    return list.find((i: CostCodeLookup) => {
        return i.keyHash === keyHash;
    }) as CostCodeLookup;
}

export function findById(list: any[], id: Maybe<number> | number | undefined): any | undefined {
    if (!list || list.length === 0 || !HasValue(id)) {
        return undefined;
    }

    return list.find((a: any) => {
        return a.id === id;
    });
}

export function isMinimumsRequiredCompany(companyId: number): boolean {
    if (!HasValue(companyId)) {
        return false;
    }

    const index = MINIMUMS_VISIBLE_COMPANIES.findIndex((c) => {
        return c === companyId;
    });

    return index >= 0;
}
